/**
 * Empty stub for next-polyfill-module.
 * Replaces Array.at, Object.fromEntries, etc. polyfills — modern browsers have native support.
 * See: https://developer.chrome.com/docs/performance/insights/legacy-javascript
 */
